import { createContext } from 'react';

const RendererContext = createContext({
  formOptions: {}
});

export default RendererContext;
